export default "__VITE_ASSET__BN1FKn$O__"